import {IGenginePlayer} from './i-gengine-player';
import {GengineDataHolder, TWithPlayers} from './gengine-data-holder';

export class GengineRoom<DataT extends TWithPlayers>
  extends GengineDataHolder<DataT>
{
  constructor(player: IGenginePlayer, name: string) {
    super(name, 'room', player, player.world);
  }
}
